module.exports = __webpack_public_path__ + "static/media/header.f6208580.png";